import { useMemo } from 'react'

import { useDirectReportAssessmentAverages } from '../services/users.convex'
import { processTimeseries } from '../utils/positionProgressChart.utils'
import { PositionProgressChart } from './PositionProgressChart'

interface Props {
  userId: string
}

/**
 * Progress chart for a direct report, sourced from Convex.
 *
 * Accepts a Convex user _id (not a Kinde/Postgres UUID).
 */
export function ConvexDirectReportPositionProgressChart({ userId }: Props) {
  const {
    data: timeseries,
    isLoading,
    error,
  } = useDirectReportAssessmentAverages(userId)

  const chartData = useMemo(() => processTimeseries(timeseries), [timeseries])

  return (
    <PositionProgressChart
      data={chartData}
      isLoading={isLoading}
      error={error}
    />
  )
}
